var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "p-l-5 m-b-10" }, [
    _c("div", { staticClass: "m-b-2 m-t-5" }, [
      _c("strong", [_vm._v(_vm._s(_vm.columnDisplayName))])
    ]),
    _vm._v(" "),
    _c("table", { staticClass: "table_beauty condensed-alternate" }, [
      _c("thead", [
        _c("tr", { staticClass: "bg-transparent" }, [
          _c("th", {
            directives: [
              { name: "t", rawName: "v-t", value: "NAME", expression: "'NAME'" }
            ]
          }),
          _vm._v(" "),
          _vm.columnName.toLowerCase() === "notacceptedtargets"
            ? _c("th", {
                directives: [
                  {
                    name: "t",
                    rawName: "v-t",
                    value: "REASON",
                    expression: "'REASON'"
                  }
                ]
              })
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c(
        "tbody",
        _vm._l(_vm.parsedHangupRerouteDetail, function(target, index) {
          return _c("tr", { key: index, staticClass: "bg-transparent" }, [
            _c("td", [
              _c(
                "a",
                {
                  staticClass: "table-ellipsis__name linked-name",
                  attrs: { rel: "noopener", target: "_blank", href: target.url }
                },
                [_c("span", [_vm._v(_vm._s(target.name))])]
              )
            ]),
            _vm._v(" "),
            _vm.columnName.toLowerCase() === "notacceptedtargets"
              ? _c("td", [
                  _c("span", [
                    _vm._v(_vm._s(target.reason ? target.reason : ""))
                  ])
                ])
              : _vm._e()
          ])
        }),
        0
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }